import { ETAT_ENREGISTRE, ETAT_FACTURE_PARTIELLEMENT } from '@/configuration/devisConf';

export default function genererCritereRechercheCommandeAFacturer(isForCommande) {
  const critere = {
    categorieVente: [],
    code: null,
    codeDossier: null,
    auto: '',
    commercialIds: null,
    assistantIds: null,
    groupeIds: [],
    factureId: null,
    etats: [ETAT_ENREGISTRE, ETAT_FACTURE_PARTIELLEMENT],
    enseigneIds: [],
    annonceursId: [],
    payeursId: [],
    aFacturer: true,
    bonAFacturer: true,
    societeId: null,
    facturationFaite: false,
    agencesIds: [],
    themes: [],
    interne: false,
    estSigne: null,
    estSigneElectroniquement: null,
    estIndexe: null,
    parutionsIds: [],
    dateCommande: {
      dateDebut: null,
      dateFin: null,
    },
    datePremierAffichage: {
      dateDebut: null,
      dateFin: null,
    },
    datesPrevisionnellesFacturationFacturee: {
      dateDebut: null,
      dateFin: null,
    },
    datesPrevisionnellesFacturationNonFacturee: {
      dateDebut: null,
      dateFin: null,
    },
    regleFacturationIds: [],
    factureParEmail: null,
    tagIds: [],
    dateCampagne: {
      dateDebut: null,
      dateFin: null,
    },
    estIndexable: null,
  };
  if (isForCommande) {
    critere.datesPrevisionnellesFacturation = {
      dateDebut: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      dateFin: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    };
  } else {
    critere.datePrevisionnelleFacturation = {
      dateDebut: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      dateFin: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    };
  }
  return critere;
}
